import axios from 'axios'

export default class ApiManagerFood {
    /**
     * Get food fast list
     */
    static async fetchFood(params) {
        return axios.get(`/back-office/food/list/fast?` + params).then((res) => res.data)
    }

    /**
     * Change food ordering
     */
    static async changeFoodOrder(payload) {
        return axios.post('/back-office/food/change/order', payload).then((res) => res.data)
    }

    /**
     * Get food categories fast list
     */
    static async fetchParentCategories(params) {
        return axios.get(`/back-office/food/category/list/fast`, { params: params }).then((res) => res.data)
    }

    /**
     * Change food categories ordering
     */
    static async changeFoodCategoriesOrder(payload) {
        return axios.post('/back-office/food/category/change/order', payload).then((res) => res.data)
    }

    /**
     * Add food tables
     */
    static async addTablesByNumbers(payload) {
        return axios.post('/back-office/food/tables/add/by-numbers', payload).then((res) => res.data)
    }

    /**
     * Get food tables list
     */
    static async fetchTables(page = 1, perPage = 10) {
        return axios
            .get('/back-office/food/tables', {
                params: {
                    ajax: true,
                    page: page,
                    per_page: perPage,
                },
            })
            .then((res) => res.data)
    }

    static async changeFoodTableOrder(payload) {
        return axios.post('/back-office/food/tables/change/order', payload).then((res) => res.data)
    }

    /**
     * Update food table
     */
    static async updateTable(id, payload) {
        return axios.put(`/back-office/food/tables/${id}`, payload).then((res) => res.data)
    }

    /**
     * Delete food table
     */
    static async deleteTable(id) {
        return axios.delete(`/back-office/food/tables/${id}`).then((res) => res.data)
    }

    /**
     * Delete multiple food tables
     */
    static async deleteTables(ids) {
        return axios.post('/back-office/food/tables/delete/multiple', { ids }).then((res) => res.data)
    }

    static async downloadQrCode(qrCodeUrl) {
        return axios
            .get(`/back-office/food/tables/download-qr-code`, {
                params: {
                    qr_code_url: qrCodeUrl,
                },
                responseType: 'blob',
            })
            .then((res) => res.data)
    }

    static async exportQrPdf() {
        return axios
            .get(`/back-office/food/tables/export-qr-pdf`, {
                responseType: 'blob',
            })
            .then((res) => res.data)
    }

    static async exportExcel() {
        return axios
            .get(`/back-office/food/tables/export-excel`, {
                responseType: 'blob',
            })
            .then((res) => res.data)
    }

    static async exportCsv() {
        return axios
            .get(`/back-office/food/tables/export-csv`, {
                responseType: 'blob',
            })
            .then((res) => res.data)
    }
}
